module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.ac35bf2.woff2";